<script setup lang="ts">
import Wrapper from '../ui/wrapper/Wrapper.vue';
import Content from '../ui/content/Content.vue';
import { Header } from '~/widgets/header/';
import { Footer } from '~/widgets/footer/';
import { CookieBanner } from '~/widgets/cookie-banner';

onErrorCaptured((error, instance, info) => {
  console.error('Error captured:', error);
  console.error('Component instance:', instance);
  console.error('Error info:', info);
});

const isArticle = computed(() => useRoute().meta.layoutType === 'article');

// Partner article: no site-wide banner and no side feed. The flag is set
// by the partner-article.global middleware before render, so it is already
// correct during SSR.
const isPartnerView = useState<boolean>('is-partner-article', () => false);

const isNeedChangeTab = ref(false);
provide('isNeedChangeTab', isNeedChangeTab);
</script>

<template>
  <Wrapper>
    <Header />
    <BannerSiteTop v-if="!isPartnerView" />
    <Content
      :class="[$style.content, { [$style.content_article!]: isArticle }]"
    >
      <div
        :class="[
          $style.inside,
          {
            [$style.inside_article!]: isArticle,
            [$style.inside_partner!]: isPartnerView,
          },
        ]"
      >
        <slot />
      </div>
    </Content>
    <Footer />
    <CookieBanner />
  </Wrapper>
</template>

<style module lang="scss">
.content {
  &_article {
    flex-direction: row-reverse !important;
  }
}

.inside {
  border-left: 1px solid var(--color-gray-line);
  height: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;

  &_article {
    border-left: none;
    border-right: 1px solid var(--color-gray-line);
    height: 100%;
    display: block;
  }

  // Partner article: gray backdrop, no divider against the side feed
  &_partner {
    background: var(--color-gray-bg);
    border-right: none;
  }
}

@media (max-width: 1023px) {
  .inside {
    border-left: none;
    min-height: inherit;
    &_article {
      border-right: none;
    }
  }
}
</style>
